import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOrderHistoryComponent } from './custom-order-history.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomOrderService } from '../../core/order.service';
import { OrderAdapter, OrderConnector } from '@spartacus/order/core';
import { OccOrderAdapter } from '@spartacus/order/occ';
import { PageTitle } from '../../../store-front/misc/page-title/page-title.component';
import { DatePickerModule } from 'primeng/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule } from '@spartacus/storefront';
import { LocalLoaderComponent } from '../../../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../../../components/table-pro/table-pro.component';
import { RouterModule } from '@angular/router';
import { AllowedKeysToDatePickerModule } from '../../../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';

@NgModule({
  declarations: [CustomOrderHistoryComponent],
  imports: [
    CommonModule,
    PageTitle,
    DatePickerModule,
    ReactiveFormsModule,
    I18nModule,
    FormErrorsModule,
    LocalLoaderComponent,
    TableProComponent,
    RouterModule,
    AllowedKeysToDatePickerModule,
  ],
  providers: [
    CustomOrderService,
    OrderConnector,
    {
      provide: OrderAdapter,
      useClass: OccOrderAdapter,
    },
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CustomOrderHistoryComponent: {
          component: CustomOrderHistoryComponent,
        },
      },
    }),
  ],
})
export class CustomOrderHistoryModule {}
